import { render, staticRenderFns } from "./orderCgShddApprove.vue?vue&type=template&id=b0c9b5a6&scoped=true"
import script from "./orderCgShddApprove.vue?vue&type=script&lang=js"
export * from "./orderCgShddApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgShddApprove.vue?vue&type=style&index=0&id=b0c9b5a6&prod&scoped=true&lang=css"
import style1 from "./orderCgShddApprove.vue?vue&type=style&index=1&id=b0c9b5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c9b5a6",
  null
  
)

export default component.exports